import { render } from "./NotificationItemComponent.vue?vue&type=template&id=6e5b4f6e&scoped=true"
import script from "./NotificationItemComponent.vue?vue&type=script&lang=js"
export * from "./NotificationItemComponent.vue?vue&type=script&lang=js"

import "./NotificationItemComponent.vue?vue&type=style&index=0&id=6e5b4f6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5b4f6e"]])

export default __exports__